module.exports = __webpack_public_path__ + "static/img/banner.34e47b34.png";